module.exports = __webpack_public_path__ + "media/images/admin/icons/zap-off-836ce2dd046e7891d0756051baa5b923.svg";